
document.addEventListener('DOMContentLoaded', function() {
  initializeAll();

  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('upsell-add-button')) {
      const isGreetingCard = event.target.getAttribute('data-greeting-card') === 'true';
      const variantId = event.target.getAttribute('data-variant-id');
      if (isGreetingCard) {
        showGreetingCardPopover(variantId, event.target);
      } else {
        addToCartFromUpsell(variantId, event.target);
      }
    } else if (event.target.classList.contains('upsell-prev')) {
      handlePrevClick();
    } else if (event.target.classList.contains('upsell-next')) {
      handleNextClick();
    } else if (event.target.id === 'submit-greeting-card') {
      submitGreetingCardMessage();
    } else if (event.target.id === 'cancel-greeting-card') {
      hideGreetingCardPopover();
    } else if (!event.target.closest('#greeting-card-popover')) {
      hideGreetingCardPopover();
    }
  });

  document.addEventListener('touchstart', function(event) {
    if (event.target.closest('.upsell-product-slider')) {
      handleTouchStart(event);
    }
  });

  document.addEventListener('touchend', function(event) {
    if (event.target.closest('.upsell-product-slider')) {
      handleTouchEnd(event);
    }
  });

  document.addEventListener('cartUpdated', function() {
    initializeAll();
  });

  document.addEventListener('cartOpened', function() {
    initializeAll();
  });
});

let currentIndex = 0;
let touchstartX = 0;
let touchendX = 0;
let currentVariantId = null;
let currentButton = null;

function handlePrevClick() {
  const slider = document.querySelector('.upsell-product-slider');
  if (currentIndex > 0) {
    currentIndex--;
  } else {
    currentIndex = slider.children.length - 1;
  }
  updateSlider();
  hideGreetingCardPopover(); // Reset the popover when navigating
}

function handleNextClick() {
  const slider = document.querySelector('.upsell-product-slider');
  if (currentIndex < slider.children.length - 1) {
    currentIndex++;
  } else {
    currentIndex = 0;
  }
  updateSlider();
  hideGreetingCardPopover(); // Reset the popover when navigating
}

function updateSlider() {
  const slider = document.querySelector('.upsell-product-slider');
  const offset = -currentIndex * slider.clientWidth;
  slider.style.transform = `translateX(${offset}px)`;
  
  // Ensure the popover is hidden when the slider is updated
  hideGreetingCardPopover();
}


function handleTouchStart(event) {
  touchstartX = event.changedTouches[0].screenX;
}

function handleTouchEnd(event) {
  touchendX = event.changedTouches[0].screenX;
  handleGesture();
}

function handleGesture() {
  if (touchendX < touchstartX) {
    handleNextClick();
  }
  if (touchendX > touchstartX) {
    handlePrevClick();
  }
}

function initializeAll() {
  initializeSlider();
  initializeTouchEvents();
}

function initializeSlider() {
  const slider = document.querySelector('.upsell-product-slider');
  if (!slider) {
    return;
  }
  initializeTouchEvents();
}

function initializeTouchEvents() {
  const slider = document.querySelector('.upsell-product-slider');
  if (!slider) {
    return;
  }
  slider.removeEventListener('touchstart', handleTouchStart);
  slider.removeEventListener('touchend', handleTouchEnd);
  slider.addEventListener('touchstart', handleTouchStart);
  slider.addEventListener('touchend', handleTouchEnd);
}

function showGreetingCardPopover(variantId, button) {
  currentVariantId = variantId;
  currentButton = button;
  const popover = document.getElementById('greeting-card-popover');

  // Calculate the position
  const buttonRect = button.getBoundingClientRect();
  const popoverHeight = popover.offsetHeight;
  const popoverWidth = popover.offsetWidth;

  // Position the popover fixed to bottom and left
  popover.style.display = 'block'; // Ensure the popover is visible to get accurate dimensions
  popover.style.bottom = '75px';
  popover.style.left = '112px';
  popover.style.zIndex = 1200; // Ensure high z-index

  // Adjust popover position if it goes out of viewport
  const popoverRect = popover.getBoundingClientRect();

  if (popoverRect.right > window.innerWidth) {
    popover.style.left = `${window.innerWidth - popoverWidth - 10}px`; // 10px padding from the right edge
  }
  if (popoverRect.left < 0) {
    popover.style.left = `10px`; // 10px padding from the left edge
  }
  if (popoverRect.bottom > window.innerHeight) {
    popover.style.top = `${window.innerHeight - popoverHeight - 10}px`; // 10px padding from the bottom edge
  }
  if (popoverRect.top < 0) {
    popover.style.top = `10px`; // 10px padding from the top edge
  }
}


function hideGreetingCardPopover() {
  const popover = document.getElementById('greeting-card-popover');
  const sliderWrapper = document.querySelector('.upsell-product-slider-wrapper');
  const greetingCardMessage = document.getElementById('greeting-card-message-upsell');

  greetingCardMessage.value = ''; // Clear the text area
  popover.style.display = 'none';
  popover.style.zIndex = 1101; // Ensure zIndex is set correctly

  // Restore overflow hidden
  sliderWrapper.style.overflow = 'hidden';

  currentVariantId = null;
  currentButton = null;
}

function hideGreetingCardPopover() {
  const popover = document.getElementById('greeting-card-popover');
  const greetingCardMessage = document.getElementById('greeting-card-message-upsell');

  greetingCardMessage.value = ''; // Clear the text area
  popover.style.display = 'none';
  popover.style.zIndex = 1101; // Reset zIndex
  currentVariantId = null;
  currentButton = null;
}
  
function submitGreetingCardMessage() {
  const message = document.getElementById('greeting-card-message-upsell').value.trim();
  if (message) {
    addToCartFromUpsell(currentVariantId, currentButton, { 'Greeting Card Message': message });
    hideGreetingCardPopover();
  } else {
    alert('Please enter a message for the greeting card.');
  }
}

function addToCartFromUpsell(variantId, button, properties = {}) {
  const form = document.getElementById('hidden-cart-form');
  form.querySelector('#hidden-product-id').value = variantId;

  button.querySelector('.loading__spinner').style.display = 'block';
  button.setAttribute('disabled', true);
  button.classList.add('disabled');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(form);
  formData.append('sections', 'cart-drawer,cart-icon-bubble');
  formData.append('sections_url', window.location.pathname);

  for (const key in properties) {
    formData.append(`properties[${key}]`, properties[key]);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'upsell-add-button',
          productVariantId: variantId,
          errors: response.errors || response.description,
          message: response.message,
        });
        console.error('Error adding to cart:', response);
      } else {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'upsell-add-button',
          productVariantId: variantId,
          cartData: response,
        });
        updateCartContents(response);
      }
    })
    .catch((e) => {
      console.error('Error:', e);
    })
    .finally(() => {
      // Hide loading spinner and re-enable button
      button.querySelector('.loading__spinner').style.display = 'none';
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    });
}

function updateCartContents(response) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && typeof cart.renderContents === 'function') {
    cart.renderContents(response);
    document.dispatchEvent(new Event('cartUpdated'));
  } else {
    console.error('Cart component not found or renderContents method is missing.');
  }
}
